interface IRecentOperateInfo {
    eventName: string;
    time: number;
    count: number;
}

export interface IRelateOperateInfo {
    firstEvent: string, // 在此时间段内的首个用户行为
    maxEvent: string, // 在此时间段内单帧重复操作最多的用户行为
    maxCount: number, // 在此时间段内单帧重复操作最多的次数
}

const USER_OPERATE_ARR = ['mousedown', 'touchstart', 'scroll']; // 记录哪些操作
const RECENT_LIST_SIZE = 5; // 记录最近多少次操作
const EFFECT_TIME_BEFORE = 500; // 卡顿前后多少ms内的操作认为是本次卡顿相关的操作

/**
 * 卡顿与用户行为关系获取模块
 */
export default class UserOperateJank {
    private userOperateFirstTime = 0;
    private userOperateCount = 0;
    private recentOperateList: IRecentOperateInfo[] = [];
    private eventMap = new Map();

    public constructor() {
        this.addUserOperateListener();
    }

    public destory() {
        this.removeUserOperateListener();
    }

    /**
     * 获取当前时间段相关的用户行为信息
     * @param lastRenderTime
     * @param nowRenderTime
     */
    public getRelateOperateInfo(lastRenderTime: number, nowRenderTime: number): IRelateOperateInfo | null {
        const startTime = lastRenderTime - EFFECT_TIME_BEFORE;
        const endTime = nowRenderTime + EFFECT_TIME_BEFORE;
        const relateOperateList = this.recentOperateList.filter(item => item.time >= startTime && item.time <= endTime);
        if (relateOperateList.length === 0) {
            return null;
        }
        let maxCount = 0;
        let firstEvent = '';
        let maxEvent = '';
        relateOperateList.forEach((item, index) => {
            if (index === 0) {
                firstEvent = item.eventName;
            }
            if (item.count > maxCount) {
                maxCount = item.count;
                maxEvent = item.eventName;
            }
        });
        return {
            firstEvent,
            maxEvent,
            maxCount,
        };
    }

    /**
     * 添加监听用户行为
     */
    private addUserOperateListener() {
        USER_OPERATE_ARR.forEach((eventName) => {
            const eventCallback = this.recordUserOperate.bind(this, eventName);
            this.eventMap.set(eventName, eventCallback);
            window.document.addEventListener(eventName, eventCallback, { capture: true });
        });
    }

    /**
     * 移除监听用户行为
     */
    private removeUserOperateListener() {
        this.eventMap.forEach((eventCallback, eventName) => {
            window.document.removeEventListener(eventName, eventCallback, { capture: true });
        });
    }

    /**
     * 记录用户的最近几次单帧内的操作
     * @param eventName
     * @private
     */
    private recordUserOperate(eventName: string) {
        if (!this.userOperateFirstTime) {
            this.userOperateFirstTime = Date.now();
        }
        this.userOperateCount = this.userOperateCount + 1;
        requestAnimationFrame(() => {
            if (this.userOperateCount > 0 && this.userOperateFirstTime) {
                const operateInOneFrame = {
                    eventName,
                    time: this.userOperateFirstTime,
                    count: this.userOperateCount,
                };
                this.recentOperateList.push(operateInOneFrame);
                if (this.recentOperateList.length > RECENT_LIST_SIZE) {
                    this.recentOperateList.shift();
                }
            }
            this.userOperateFirstTime = 0;
            this.userOperateCount = 0;
        });
    }
}
